import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { useContextSite } from "../../../context/Context";
import { useVisualizarLoteAgendamento } from "../../../hooks/queries/loteAgendamento/useVisualizarLoteAgendamento/useVisualizarLoteAgendamento";
import { Tracking } from "../../../services/Tracking";
import { SERVICO_POR_TIPO_SERVICO } from "../../../constants/servico_lote";
import { TipoServicoLote } from "../../../types/loteAgendamento";

export const useBatchCreatedAppointments = () => {
  const navigate = useNavigate();
  const { uuidAgendamento } = useParams<{ uuidAgendamento: string }>();
  const [searchParams] = useSearchParams();
  const tipoServico = searchParams.get("tipoServico") as TipoServicoLote | null;
  const stepIndicator = useAgendamentoStepIndicator();
  const { setIsLoad } = useContextSite();

  const { data: loteAgendamento, isLoading } =
    useVisualizarLoteAgendamento(uuidAgendamento);

  useEffect(() => {
    setIsLoad(isLoading);
  }, [isLoading]);

  useEffect(() => {
    Tracking.pageView("mapa:agendamento-lote/agendamentos-criados:pageview");
  }, []);

  const agendamentos = loteAgendamento?.agendamentos ?? [];
  const tipoAtendimento = loteAgendamento?.tipoAtendimento;
  const valorTotal = loteAgendamento?.valorTotal;
  const servico = tipoServico ? SERVICO_POR_TIPO_SERVICO[tipoServico] : undefined;
  const identificador: "placa" | "chassi" =
    tipoServico === "primeiro-emplacamento" ? "chassi" : "placa";

  function navigateHome() {
    navigate("/agendamento/inicio");
  }

  function navigateToMeusAgendamentos() {
    navigate("/meus-agendamentos");
  }

  return {
    stepIndicator,
    agendamentos,
    tipoAtendimento,
    valorTotal,
    servico,
    identificador,
    navigateHome,
    navigateToMeusAgendamentos,
  };
};
